import { LIBRARY_INFO } from 'components/assets/libraries'
import { Breadcrumbs } from 'components/ui'
import { useCurrentUser } from 'context/current-user-context'
import { useRouter } from 'next/router'
import { FC } from 'react'

type AssetSectionBreadcrumbsProps = {
  path?: string
  pathLabel?: string
}
export const AssetSectionBreadcrumbs: FC<AssetSectionBreadcrumbsProps> = ({
  path,
  pathLabel,
}) => {
  const router = useRouter()
  const basePath = router.query.assetType
    ? String(router.query.assetType)
    : router.asPath.split('/')[1]
  const { team } = useCurrentUser()

  const libraryInfo = LIBRARY_INFO.find((info) => info.basePath == basePath)
  if (!libraryInfo) {
    return <></>
  }

  return (
    <Breadcrumbs.List>
      <Breadcrumbs.Item to="/" previous>
        {team}
      </Breadcrumbs.Item>

      <Breadcrumbs.Item to={'/' + libraryInfo.basePath} current={!path}>
        {libraryInfo.label}
      </Breadcrumbs.Item>
      {Boolean(path && pathLabel) && (
        <Breadcrumbs.Item to={`/${libraryInfo.basePath}/${path}`} current>
          {`${pathLabel}`}
        </Breadcrumbs.Item>
      )}
    </Breadcrumbs.List>
  )
}
